import React, { useState, ReactElement } from "react";
import { TextField, Button, Grid, Container, Typography, Card, CardActionArea, CardMedia, CardContent, Box, Tab, Tabs } from "@mui/material";
import {
  MessageContainer,
  DownloadButton,
  BackButton,
  CloseButton,
  FullContainer,
  ButtonContainer
} from "./ctepdownload.styled"
import { useNavigate } from 'react-router-dom';
import { ReactComponent as DownloadIcon } from "assets/images/Download_white.svg";


function CTEPDownload(props) {
  const navigate = useNavigate();

  const CloseButtonClick = () => {
    navigate(-1);
  }

  const prevButtonClick = () => {
    props.onPrevButtonClick()
  }

  const downloadReport = () => {
    let reportName = ""
    if (props.downloadLink.indexOf("docx") > 0) {
      reportName = 'SAR_Report_for_' + props.intakeData.solname + '.docx'
    } else if (props.downloadLink.indexOf("pdf") > 0) {
      reportName = 'SAR_Report_for_' + props.intakeData.solname + '.pdf'
    } else if (props.downloadLink.indexOf("xlsx") > 0) {
      reportName = 'SAR_Report_for_' + props.intakeData.solname + '.xlsx'
    }


    let message = props.downloadLink
    const lastDigit = /\d(?!.*\d)/;
    const match = message.match(lastDigit);
    message = message.slice(message.indexOf('https'), match.index + 1)

    const link = document.createElement('a');
    link.href = message;
    link.setAttribute(
      'download',
      reportName,
    );
    link.setAttribute(
      'target',
      `_blank`,
    );


    // Append to html link element page
    document.body.appendChild(link);
    link.click();
  }

  return (
    <FullContainer>
      <MessageContainer>
        <DownloadButton onClick={downloadReport} name="download">
          <DownloadIcon style={{ position: "relative", right: ".5em" }} onClick={downloadReport} name="downloadIcon" />
          Download my custom Report
        </DownloadButton>
      </MessageContainer>
      <ButtonContainer>
        <CloseButton onClick={CloseButtonClick}>Close</CloseButton>
      </ButtonContainer>
    </FullContainer>



  );
}

export default CTEPDownload;